import { ref, watch } from 'vue';
import { loadPlatformPolicy } from 'dashboard/helper/platformPolicy';
import { normalizeAccountId } from 'dashboard/helper/platformPolicyRules';

export const usePlatformPolicy = accountId => {
  const policy = ref(null);
  const isPolicyLoading = ref(true);

  watch(
    accountId,
    async currentAccountId => {
      const requestedAccountId = normalizeAccountId(currentAccountId);
      policy.value = null;
      isPolicyLoading.value = true;

      const loadedPolicy = await loadPlatformPolicy(requestedAccountId);
      if (normalizeAccountId(accountId.value) !== requestedAccountId) return;

      policy.value = loadedPolicy;
      isPolicyLoading.value = false;
    },
    { immediate: true }
  );

  return { policy, isPolicyLoading };
};
